export enum NotificationSeverity {
  Critical = 'Critical',
  Warning = 'Warning',
  Informational = 'Informational',
  Announcements = 'Announcements',
  Error = 'Error',
}
